// Composable para manejar triggers personalizados + categorías custom
// Persistido en localStorage por cuenta.
import { computed, ref } from 'vue';
import { useStore } from 'vuex';

export function useCustomTriggers() {
  const store = useStore();
  const accountId = computed(() => store.getters.getCurrentAccountId);
  const key = computed(() => `victorpos:custom-triggers:${accountId.value}`);

  const triggers = ref([]);
  const categories = ref([]);

  function load() {
    try {
      const raw = localStorage.getItem(key.value);
      if (!raw) return;
      const data = JSON.parse(raw);
      triggers.value = Array.isArray(data.triggers) ? data.triggers : [];
      categories.value = Array.isArray(data.categories) ? data.categories : [];
    } catch (e) { /* ignore */ }
  }

  function persist() {
    try {
      localStorage.setItem(key.value, JSON.stringify({
        triggers: triggers.value,
        categories: categories.value,
      }));
    } catch (e) { /* ignore */ }
  }

  function uid() {
    return `c-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 7)}`;
  }

  // ── Triggers ──
  function saveTrigger(trigger) {
    if (trigger.id) {
      const idx = triggers.value.findIndex(t => t.id === trigger.id);
      if (idx >= 0) triggers.value[idx] = { ...trigger };
    } else {
      triggers.value.push({ ...trigger, id: uid() });
    }
    persist();
  }

  function deleteTrigger(id) {
    triggers.value = triggers.value.filter(t => t.id !== id);
    persist();
  }

  // ── Categorías ──
  function saveCategory(category) {
    if (category.id) {
      const idx = categories.value.findIndex(c => c.id === category.id);
      if (idx >= 0) categories.value[idx] = { ...category };
    } else {
      categories.value.push({ ...category, id: uid() });
    }
    persist();
  }

  function deleteCategory(id) {
    // Triggers de esa categoría pasan a ser sin categoría → quedan en grupo "Personalizados"
    triggers.value = triggers.value.map(t => t.categoryId === id ? { ...t, categoryId: null } : t);
    categories.value = categories.value.filter(c => c.id !== id);
    persist();
  }

  load();
  return { triggers, categories, saveTrigger, deleteTrigger, saveCategory, deleteCategory, load };
}
